import React, { useContext, useEffect, useState } from 'react';
import msg from '../Tools/MsgUtils';
import { ReactSession } from "react-client-session";
import MsgUtils from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

//const productos = [{ 'id': 1, 'nombre': 'POLLO', 'idProductos': [1,2,3,4,5,6,7] }, 
//{ 'id': 2, 'nombre': 'PIPOCA', 'idProductos': [111, 1801]},]

function ReportePollosAlmacenes() {
    
    const { loading, setLoading } = useContext(ContextGloball);
    const [listaProductos, setListaProductos] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    const [regional, setRegional] = useState(0);

    useEffect(() => {
         
        var info = JSON.parse(localStorage.getItem('info'));
        setRegional(info.ID_REGIONAL_ACTUAL);

        setLoading(true);

        fetch(`${server}/reporte/getProductosPrueba`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'regional': info.ID_REGIONAL_ACTUAL,
                'id_sucursal': 0,
                'id_almacen' : 1
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setListaProductos(data.ok)
                    setLoading(false);
                } else {
                    MsgUtils.msgError("No se pudo obtener el reporte.");
                }
            })
            .catch(err => MsgUtils.msgError(err));

    }, [actualizar]);

    return (
        <div>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='row g-2'>
                    <div className='col ' style={{ maxWidth: '140px' }}>
                        <button className='btn btn-success bg-gradient w-100' onClick={() => setActualizar(!actualizar)}>
                            <i className="fa-solid fa-spinner"></i> Actualizar
                        </button>
                    </div>
                </div>
            </div>
            
            {loading === false &&
                <div className='container-fluid py-2 table-responsive'>
                    <table className="table table-sm table-striped table-hover">
                        <thead>
                            <tr>
                                <th scope="col">DESCRIPCION</th>
                                <th scope="col">STOCK</th>
                                <th scope="col">UNIDAD</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listaProductos.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{item.DESCRIPCION}</td>
                                        <td>{item.CANTIDAD.toFixed(2)}</td>
                                        <td>{item.UNIDAD}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    )
}

export default ReportePollosAlmacenes
